import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'antd';
import { setModalState } from '../../../../reducers/Modal/actions';
import { PRE_DEALS_MODAL_TRAINING } from '../../../../reducers/Modal/types';
import { ZorbaButton } from '../../../../components/forms';
import { postRequest } from '../../../../services/requestService';
import { getUserData } from '../../../../reducers/Auth/actions';
import { isMobile } from '../../../../services/clientService';

import './index.scss';

export const PreDealsTrainingModal = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { userDetails, isAppLoading, isAuthLoading } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );
  const { isPreDealsTrainingModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !isAppLoading &&
      !isAuthLoading &&
      userDetails &&
      userDetails?.defaultOrganization?.buyersAppFeatureFlags?.preDeals
        ?.isActive &&
      !userDetails?.watchedPreDealsTrainingAt
    ) {
      dispatch(setModalState(PRE_DEALS_MODAL_TRAINING, true));
    }
  }, [userDetails, isAuthLoading, isAppLoading]);

  const handleCloseModal = async () => {
    setIsLoading(true);
    if (!userDetails?.watchedPreDealsTrainingAt) {
      await postRequest('/user/update-pre-deals-watched-training');
    } else {
      history.push('/?tab=pre-lock-properties');
    }
    setIsLoading(false);
    dispatch(getUserData());
    dispatch(setModalState(PRE_DEALS_MODAL_TRAINING, false));
  };

  const videoSrc =
    'https://www.youtube.com/embed/xKJ_BZ2nLbs?si=Hf9z3yY_qA808Z15_&cc_load_policy=1&cc_lang_pref=en';

  return (
    <Modal
      open={isPreDealsTrainingModalOpen}
      footer={null}
      className="training-modal"
      destroyOnClose
      centered={!isMobile()}
      width={!isMobile() ? 740 : ''}
      style={isMobile() ? { top: 200 } : {}}
      closable={Boolean(userDetails?.watchedPreDealsTrainingAt)}
      onCancel={
        userDetails?.watchedPreDealsTrainingAt ? handleCloseModal : null
      }
    >
      <div className="video-responsive">
        <div className="title-container">
          <span className="title">Introducing: Pre-lock Inventory™</span>
          <span className="description">
            Get access to deals that haven’t hit the market yet, where our
            partners will create back-to-back contracts based on your offer
            terms.
          </span>
        </div>
        <iframe
          width={!isMobile() ? '640' : ''}
          height={!isMobile() ? '360' : ''}
          src={videoSrc}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
      <div className="buttons-container">
        <ZorbaButton
          fullWidth={false}
          onClick={handleCloseModal}
          disabled={isLoading}
          loading={isLoading}
        >
          {userDetails?.watchedPreDealsTrainingAt
            ? 'Close'
            : 'Start free trial'}
        </ZorbaButton>
      </div>
    </Modal>
  );
};
